import React from 'react';
import { MessageWrapper, Snippet } from '@components/html-injection/styled.ts';
import { findHtmlError } from '@utils/general.tsx';
import type { Config as DOMPurifyConfig } from 'dompurify';
import DOMPurify from 'dompurify';
import type { HTMLReactParserOptions } from 'html-react-parser';
import parse from 'html-react-parser';

interface HtmlInjectionProps {
    text: string;
    options?: HTMLReactParserOptions;
    sanitizeConfig?: DOMPurifyConfig;
}

interface HtmlParseError {
    message: string;
    snippet: string;
}

export const HtmlInjection: React.FC<HtmlInjectionProps> = ({ text, options, sanitizeConfig = {} }) => {
    let content: React.ReactNode;

    try {
        const clean = DOMPurify.sanitize(text, sanitizeConfig);
        content = parse(clean, options);

        const error = findHtmlError(text);
        if (error) throw error;
    } catch (error) {
        const err = error as HtmlParseError;
        content = (
            <MessageWrapper>
                <strong>HTML parse error:</strong> {err.message}
                <Snippet>{err.snippet}</Snippet>
            </MessageWrapper>
        );
    }

    return content;
};
